import { useEffect, useMemo, useState } from "react";
import AxiosInstance, { IMAGE_BASE_URL, TokenService } from "../../../../services/Api";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import styles from "../index.module.css";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaPen, FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import PopupModal from "../../../../components/PopupModal/PopupModal";
const ViewAnnouncement = () => {
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || {};
  const school_id = clientData?.school_id || "";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [apiSearch, setApiSearch] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [selectedId, setSelectedId] = useState(null);
  const [rows, setRows] = useState([]);
  const [modalState, setModalState] = useState({
    open: false,
    type: "success",   // "success" | "error"
    message: "",
    redirectPath: "",
  });
  const navigate = useNavigate();
  const handleEdit = (data) => {
    if (selectedId) {
      navigate("/user/AddAnouncement", {
        state: {
          ID: selectedId,
          // DATA: data[1]
        }
      })
    } else {
      alert("Choose any one row!")
    }
  }
  const handleDelete = async (data) => {
    if (selectedId) {
      const payload = {
        id: selectedId
      };
      const response = await AxiosInstance.post(
        `/school/deleteAnnouncement`,
        payload
      );
      if (response.data?.status) {
        setModalState({
          open: true,
          type: "success",
          message: response.data?.message,
          redirectPath: "/user/ViewAnnouncement",
        });

      } else {
        setModalState({
          open: true,
          type: "error",
          message: response.data?.message,
          redirectPath: "",
        });
        throw new Error(response.data?.message || "Message send failed");
      }

    } else {
      alert("Choose any one row!")
    }
  }
  const handleCreate = () => {
    navigate("/user/AddAnouncement")
  }
  // ================= API CALL =================
  const fetchAnnouncement = async () => {
    setLoading(true);

    try {
      const response = await AxiosInstance.post("/school/listAnnouncement", {
        school_id,
        search: apiSearch,
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
      });
      const mappedRows = response.data.data.map((item) => ({
        id: item.id,
        subject: item.subject,
        content: item.content,
      }));

      setRows(mappedRows);
      setData(response.data?.data || []);
      setRowCount(response.data?.pagination?.total || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAnnouncement();
  }, [pagination.pageIndex, pagination.pageSize, apiSearch]);

  const { language, translations } = useSelector((state) => state.language);




  // ================= COLUMNS =================
  const columns = useMemo(() => [
    {
      accessorKey: "subject",
      header: translations.labels.subject,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Subject",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      accessorKey: "content",
      header: translations.labels.content,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Content",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      id: "select",
      header: translations.labels.select,
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <input
          type="radio"
          name="hallOfFameSelect"
          checked={selectedId == row.original.id}
          onChange={() => setSelectedId(row.original.id)}

        />
      ),
    },
  ], [selectedId]);
  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;
    setModalState((prev) => ({
      ...prev,
      open: false,
    }));
    if (type === "success" && redirectPath) {
      fetchAnnouncement();
      navigate(redirectPath);
    }
  };
  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />
      <div className={styles.topBar}>
        <div>

        </div>

        <div className={styles.actions}>
          <button className={styles.iconBtn} onClick={handleCreate} ><FaPlus /></button>
          <button className={styles.iconBtn} onClick={() => handleEdit(rows)}><FaPen /></button>
          <button className={styles.iconBtn} onClick={() => handleDelete(rows)}><FaTrash /></button>
        </div>
      </div>
      <CustomMRTTable
        columns={columns}
        data={data}
        loading={loading}
        placeholder={translations.labels.searchButton}
        pagination={pagination}
        rowCount={rowCount}
        onPaginationChange={setPagination}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        onSearchEnter={(value) => {
          setApiSearch(value);
          setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        }}
      />
    </>

  );
};

export default ViewAnnouncement;


